import React, { useState } from "react";
import {
  Container,
  Typography,
  Box,
  Button,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  TextField,
  InputAdornment,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";
import { Search } from "lucide-react";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import Header from "../components/Admin/header/Header";
import CloseIcon from "@mui/icons-material/Close";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { EditIcon } from "../comps/CustomIcons";

import {
  DEFAULT_LIMIT,
  DEFAULT_ROWS_PER_PAGE_OPTIONS,
} from "../utils/constants";
import {
  MASTER_COUNTRY_DATA,
  MASTER_PACKAGE_DATA,
  MASTER_STATE_DATA,
} from "../_mock/mock";
import CountryModal from "../components/item_master/modal/country-modal";
import StateModal from "../components/item_master/modal/state-modal";
import { deleteStateByIdApi, getStateApi } from "../services/state.service";
import { useGetApi } from "../hooks/useGetApi";
import { toast } from "react-toastify";
import Loader from "../components/Loader/loader";
import ErrorMessage from "../components/ErrorMessage/errorMessage";
import PackageModal from "../components/item_master/modal/package-modal";
import { useNavigate } from "react-router-dom";
const headLabel = [
  {
    id: 1,
    label: "Code",
    value: "code",
  },

  {
    id: 2,
    label: "Name ",
    value: "name",
  },

  {
    id: 4,
    label: "Type",
    value: "type",
  },
  {
    id: 5,
    label: "Status",
    value: "status",
  },
  {
    id: 6,
    label: "",
    value: "",
  },
];

export default function MasterPackage() {
  const [search, setSearch] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_LIMIT);
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleModalOpen = () => {
    setModalOpen(true);
  };
  const handleEditPackage = (rowData) => {
    navigate(rowData?._id);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedRow(null);
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex" }}>
        <Box>
          <Sidebar />
        </Box>
        <Box sx={{ width: "100%", pr: "90px" }}>
          {/* Search and Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              my: "20px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit" }}>Package Master</Typography>
            <IconButton>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              my: "20px",
            }}
          >
            <TextField
              placeholder="Search"
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <select className="uid-select" defaultValue={"category"}>
                        <option value="category">Category</option>
                        <option value="code">Code</option>
                        <option value="department">Department</option>
                        <option value="name">Name</option>
                        <option value="packageType">Package Type</option>
                        <option value="status">Status</option>
                        <option value="subCategory">Sub Category</option>
                      </select>
                      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                      <Search />
                    </InputAdornment>
                  ),
                },
              }}
              value={search || ""}
              onChange={(event) => setSearch(event.target.value || "")}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  display: "flex",
                  gap: 0.5,
                  minWidth: "150px",
                }}
                onClick={handleModalOpen}
              >
                <AddCircleOutline />
                <Typography sx={{ color: "white" }}>New Package</Typography>
              </Button>
            </Box>
          </Box>
          {/* Table */}
          <>
            <TableContainer component={Paper}>
              <Table aria-label="master ward table" sx={{ minWidth: 800 }}>
                <TableHead
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": { fontWeight: "bold" },
                  }}
                >
                  <TableRow>
                    {headLabel?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{ textAlign: option?.align || "left" }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {MASTER_PACKAGE_DATA?.map((row) => (
                    <TableRow key={row?._id}>
                      {headLabel?.map((column, index) =>
                        index !== headLabel?.length - 1 ? (
                          <TableCell key={column?.id}>
                            {column?.value === "active"
                              ? row?.[column?.value]
                                ? "Active"
                                : "Inactive"
                              : column?.value === "country"
                              ? row?.[column?.value]?.countryName || "-"
                              : row?.[column?.value] || "-"}
                          </TableCell>
                        ) : (
                          <TableCell
                            sx={{
                              textAlign: "right",
                            }}
                          >
                            <IconButton onClick={() => handleEditPackage(row)}>
                              <EditIcon
                                sx={{
                                  cursor: "pointer",
                                  color: "transparent",
                                  fontSize: "18px",
                                }}
                              />
                            </IconButton>
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination */}

            <TablePagination
              rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
              component="div"
              count={0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        </Box>
        <PackageModal
          open={modalOpen}
          onClose={handleModalClose}
          // refetch={refetch}
          selectedRow={selectedRow}
        />
      </Box>
    </Container>
  );
}
